import { defaultShouldDehydrateQuery } from "@tanstack/react-query";

export function shouldPersistQuery(
  query: Parameters<typeof defaultShouldDehydrateQuery>[0],
) {
  // Pending promises do not survive the persister's JSON serialization.
  return query.meta?.persist === true && defaultShouldDehydrateQuery(query);
}
